import { hasNoAction, isNotArchived } from '@griply/utils';
import { useAllCompletedTasks } from 'features/tasks';
import { useDeferredValue, useMemo } from 'react';
import { useRelationshipIdsById } from 'shared/hooks/use-relationships';
import { ID, IDPrefixes } from 'shared/types/id';

export const useTagCompletedTasks = (id: ID | undefined) => {
  const { task: taskIds } = useRelationshipIdsById(id, IDPrefixes.Tag);

  const deferredTaskIds = useDeferredValue(taskIds);
  // enabled keeps the completed subscription lazy while the tag has no tasks;
  // it cannot unmount the shared listener while other consumers hold it.
  const completedTasks = useAllCompletedTasks(!!deferredTaskIds.length);

  return useMemo(() => {
    const idSet = new Set(deferredTaskIds);
    return completedTasks.filter(
      (task) => idSet.has(task.id) && isNotArchived(task) && hasNoAction(task),
    );
  }, [completedTasks, deferredTaskIds]);
};
